import React ,{Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {connect} from "react-redux";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import IconButton from "@material-ui/core/es/IconButton/IconButton";
import {changeLoadingStatus, updateProfile} from "../actions";
import Backdrop from "@material-ui/core/es/Backdrop/Backdrop";
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import Button from "@material-ui/core/es/Button/Button";
import Slider from "@material-ui/core/es/Slider/Slider";
import {baseUrl, baseUrlAPI} from "../constants/constant";
import axios from "axios/index";

const styles = theme => ( {
    cover:{
        "min-height": "92vh",
        "display": "flex",
        "alignItems": "flex-start",
        "justifyContent": "center",
        "flexDirection": "row",
        "flexWrap": "wrap",
        "paddingBottom": "12vh",
        "width": "100%",
        [theme.breakpoints.up('xs')]: { //Iphone
            "fontSize": "11px",
        },[theme.breakpoints.up('sm')]: {//Iphone +
            "fontSize": "13px",
        },[theme.breakpoints.up('md')]: {
            "fontSize": "10px",
        },
        [theme.breakpoints.up('lg')]: {//Tab
            "fontSize": "10px",
        },
        [theme.breakpoints.up('xl')]: {//lap
            "fontSize": "13px",
        },
        [theme.breakpoints.up('xxl')]: {//Llap
            "fontSize": "15px",
        }
    },
    mainDiv:{
        "width": "100%",
        "display": "flex",
        "flexWrap": "wrap",
        "minHeight": "92vh",
        "alignItems": "center",
        "flexDirection": "column",
        "justifyContent": "flex-start",
        [theme.breakpoints.up('md')]: {
            "width": "50%",
        },
    },
    firstDivEditProfile:{
        "display": "flex",
        "justifyContent": "space-between",
        "alignItems": "center",
        "width": "90%"
    },
    firstLeftDivEditProfile:{
        "display": "flex",
        "justifyContent": "center",
        "alignItems": "center"
    },
    arrowIcon:{
        "backgroundColor": "#f0f8ff00",
        "width": "20%",
    },
    firstRightDivEditProfile:{
        "marginRight": "5%",
        "color": "#00ebff"
    },
    secondDivEditConnection:{
        "width": "100%",
        "display": "flex",
        "alignItems": "center",
        "flexDirection": "column",
        "justifyContent": "space-evenly",
        "height": "72vh"
    },
    fourthDivEditProfile:{
        "display": "flex",
        "justifyContent": "center",
        "alignItems": "flex-start",
        "flexDirection": "column",
        "width": "85%"
    },
    fourthDivTitleEditConnection:{
        "width": "100%",
        "display": "flex",
        "alignItems": "center",
        "justifyContent": "center",
        "marginBottom": "10%",
        "marginTop": "-10%",
        "& h3":{
            "marginBottom": "0",
            "color": "#fffbf0"
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    photoDivAddResume:{
        "display": "flex",
        "justifyContent": "center",
        "marginBottom": "3vw",
        "width": "100%",

    },
    payButton: {
        "backgroundColor": "#00ebff",
        "color": "#222",
        "fontFamily": "En",
        "width": "80%",
    },
    input: {
        display: 'none',
    },
    coverButtons:{
        "display": "flex",
        "justifyContent": "center",
        "alignItems": "center",
        "width": "90%",
        "flexDirection": "column"

    },
    mainCoverPhotoDiv:{
        "display": "flex",
        "justifyContent": "center",
        "alignItems": "center",
        "flexDirection": "column",
        "width": "100%"
    },
    paymentLogo:{
        "width": "150px",
        "height": "150px",
    },
    thirdDivInputRangeEditProfile:{
        width: "81%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "column",
        "margin": "2px auto 20px",
    },
    thirdDivRangeEditProfile: {
        color: "#ff8630",
        width: "100%",
        margin: "-12px auto",
    },
    priceDiv:{
        "width": "80%",
        "display": "flex",
        "marginBottom": "4vw",
        "& h2":{
            "margin": " 0 5px 0 0",
        }
    },
    coverProgress:{
        "display": "flex",
        "justifyContent": "center",
        "alignItems": "center",
        "width": "100%",
        "flexDirection": "column",

    },
    backdropImg:{
        width: "40vw",
        [theme.breakpoints.up('md')]: {//Iphone +
            width: "15vw",
        }
    },
    jkjl:{},
});


class PaymentComponent extends Component {
    constructor(props) {
        super(props);
        this.state =  {
            month:3,
            cost_per_month:5,
            encrypted_user_id:null,
        };
        this.handelRangeMonth = this.handelRangeMonth.bind(this);
    }

    componentDidMount(){
        this.props.changeLoadingStatus(true);
        const { user,auth} = this.props;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth.apiToken}`
        }
        axios.post(`${baseUrlAPI}/get/payment/detail`,[],{headers})
            .then(response => {
                if(response.data.status==="success") {
                    const {encrypted_user_id,cost_per_month}=response.data.data
                    this.setState({
                        encrypted_user_id:encrypted_user_id,
                        cost_per_month:cost_per_month,
                    })

                }else {

                }
                this.props.changeLoadingStatus(false);
            })
            .catch(error => {
                this.props.changeLoadingStatus(true);
            })
    }

    handelRangeMonth(e,value){
        this.setState({
            month:value
        })
    }

    handleGoBackSetting(){
        this.props.history.push(`/setting`)
    }

    handleCloseBackDrop = () => {
        this.props.changeLoadingStatus(false)
    };

    handlePaymentBtn() {
        const {encrypted_user_id,month} = this.state;
        if(encrypted_user_id){
            window.open(`http://admin.bloomsho.com/subscribe/paypal/${encrypted_user_id}/type/${month}/month/web`).focus();
        }else{
            this.props.changeSnackStatus(true,"error",`Something went wrong. Please try again.`,"center","bottom")
            setTimeout(() =>{ this.props.changeSnackStatus(false,"success",'',"center","bottom")}, 5000);
        }
    };
    render() {
        const {  classes,loading  } = this.props;
        const {month,cost_per_month} = this.state;

        return (
            <div className={classes.cover}>

                <div  className={classes.mainDiv}>

                   <div className={classes.firstDivEditProfile}>
                       <di onClick={ ()=> {this.handleGoBackSetting()}} className={classes.firstLeftDivEditProfile}>
                           <IconButton className={classes.arrowIcon} aria-haspopup="true"  color="inherit">
                               <ArrowBackIosIcon fontSize="small" />
                           </IconButton>
                       </di>

                   </div>

                    <div className={classes.secondDivEditConnection}>

                        <div className={classes.fourthDivEditProfile}>

                            <div className={classes.photoDivAddResume}>
                                <img className={classes.paymentLogo} src="/images/payment.png" alt=""/>
                            </div>

                            <div className={classes.fourthDivTitleEditConnection}>
                                <h3>This is payment description</h3>
                            </div>

                        </div>

                        <div className={classes.mainCoverPhotoDiv}>

                            <div className={classes.coverButtons}>

                               <div><h2 style={{"color": "#ff8630"}}>Active my account for {month} months</h2></div>

                                <div className={classes.thirdDivInputRangeEditProfile}>
                                    <Slider onChange={ this.handelRangeMonth} value={month} className={classes.thirdDivRangeEditProfile}   min={1} max={12} defaultValue={month}  />
                                </div>

                               <div className={classes.priceDiv}><h2>price : </h2><h2 style={{"color": "#ff8630"}}>{month*cost_per_month} USD</h2></div>

                            </div>
                            <div className={classes.coverButtons}>
                                <Button
                                    variant="outlined"
                                    color="default"
                                    className={classes.payButton}
                                    onClick={ ()=> {this.handlePaymentBtn()}}
                                >
                                    Pay & Active
                                </Button>
                            </div>

                        </div>

                    </div>



                </div>

                <Backdrop className={classes.backdrop} open={loading} onClick={this.handleCloseBackDrop}>
                    <div className={classes.coverProgress}>
                        <img className={classes.backdropImg} src="/images/logo.png" alt=""/>
                        <CircularProgress color="inherit" />
                    </div>
                </Backdrop>

            </div>

        );
    }
}

PaymentComponent.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
    return {
        appInitData : state.appInitData,
        auth : state.auth,
        user : state.auth.user,
        apiToken : state.auth.apiToken,
        loading : state.loadingProps.loading,
    }
}

export default withStyles(styles)(connect(mapStateToProps,{changeLoadingStatus})(PaymentComponent));